<script setup lang="ts">
import { useStickyWrapperComposable } from '@components/layout-wrapper/sticky-wrapper-composable.js';
const { setStickyRef, setTopRef, marginTop, height, width, position } = useStickyWrapperComposable();
</script>

<template>
    <div :class="$style.wrapper">
        <span :ref="(reference: unknown) => setTopRef(reference as Element)" :class="$style.marker"/>
        <div :ref="(reference: unknown) => setStickyRef(reference as Element)" :class="$style.sticky_wrapper">
            <slot/>
        </div>
        <div :class="$style.width_placeholder"/>
    </div>
</template>

<style lang="scss" module>
.wrapper {
    height: v-bind('height ? height + "px" : "initial"');
}
.sticky_wrapper {
    position: v-bind(position);
    top: 0;
    z-index: 10;
    width: v-bind(width);
    margin-top: v-bind('marginTop + "px"');
    background-color: #fff;
}
.marker {
    display: block;
}
.width_placeholder {
    width: v-bind(width);
}
</style>
